import React, { useState } from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { CatalogListDropdownButton } from "./catalog-list.styled";

export default function CatalogListDropdown({ items: catalogNames, onClick, itemsCountPerCatalog, selectedIndex }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div style={{ marginLeft: "auto" }}>
            <CatalogListDropdownButton variant="contained" onClick={handleClick} endIcon={<ArrowDropDownIcon />}>
                Ver Todos
            </CatalogListDropdownButton>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    "aria-labelledby": "ver-todos-button",
                }}
            >
                {catalogNames.map((item, index) => (
                    <MenuItem
                        disabled={itemsCountPerCatalog[index] === 0}
                        selected={selectedIndex === index}
                        onClick={() => {
                            onClick(index);
                            handleClose();
                        }}
                        key={item}
                    >
                        {item}
                    </MenuItem>
                ))}
            </Menu>
        </div>
    );
}
